import { render, staticRenderFns } from "./SiblingItemUpdateForm.vue?vue&type=template&id=37517f70&scoped=true&"
import script from "./SiblingItemUpdateForm.vue?vue&type=script&lang=js&"
export * from "./SiblingItemUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37517f70",
  null
  
)

export default component.exports